import React, { useState } from 'react';
import { portfolioProjects } from '../mockData';
import { MapPin, X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Portfolio = () => {
  const { language } = useLanguage();
  const t = translations[language].portfolio;
  
  const [selectedProject, setSelectedProject] = useState(null);

  return (
    <section id="portfolio" className="py-24 lg:py-32 bg-[#FAFAF8]">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-20 fade-in">
          <p className="text-[#8B7355] text-sm tracking-widest uppercase mb-4">{t.sectionLabel}</p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-['Cormorant_Garamond'] font-light text-[#2c2c2c] mb-6">
            {t.title}
          </h2>
          <div className="w-24 h-0.5 bg-[#8B7355] mx-auto mb-8"></div>
          <p className="text-lg text-gray-600 leading-relaxed">
            {t.description}
          </p>
        </div>

        {/* Portfolio Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {portfolioProjects.map((project) => (
            <div
              key={project.id}
              className="group cursor-pointer overflow-hidden bg-white shadow-md hover:shadow-2xl transition-all duration-500 rounded-sm"
              onClick={() => setSelectedProject(project)}
            >
              <div className="relative h-72 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <p className="text-white text-sm mb-2 flex items-center">
                    <MapPin size={14} className="mr-1" />
                    {project.location}
                  </p>
                  <h3 className="text-white text-xl font-semibold">{project.title}</h3>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-['Cormorant_Garamond'] font-semibold text-[#2c2c2c] mb-2">
                  {project.title}
                </h3>
                <p className="text-sm text-gray-600 mb-3 flex items-center">
                  <MapPin size={14} className="mr-1 text-[#8B7355]" />
                  {project.location}
                </p>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {project.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {selectedProject && (
        <div
          className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedProject(null)}
        >
          <div
            className="bg-white max-w-4xl w-full rounded-sm overflow-hidden relative animate-in fade-in zoom-in duration-300"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setSelectedProject(null)}
              className="absolute top-4 right-4 z-10 bg-white/90 hover:bg-white p-2 rounded-full transition-colors duration-300"
            >
              <X size={24} className="text-[#2c2c2c]" />
            </button>
            <div className="grid grid-cols-1 md:grid-cols-2">
              <div className="h-96 md:h-auto">
                <img
                  src={selectedProject.image}
                  alt={selectedProject.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-8 md:p-12">
                <p className="text-[#8B7355] text-sm tracking-widest uppercase mb-4 flex items-center">
                  <MapPin size={14} className="mr-1" />
                  {selectedProject.location}
                </p>
                <h3 className="text-3xl md:text-4xl font-['Cormorant_Garamond'] font-light text-[#2c2c2c] mb-6">
                  {selectedProject.title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-8">
                  {selectedProject.description}
                </p>
                <button
                  onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                  className="bg-[#8B7355] hover:bg-[#6d5a42] text-white px-8 py-3 rounded-none transition-all duration-300 hover:shadow-lg"
                >
                  {t.startProjectBtn}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Portfolio;